import styled from 'styled-components';
import LogoCard from 'assets/img/LogoCard.svg';
import { Login } from 'triider-components';

import { colors, fonts, device } from '../../styles/stylesheets';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  font-family: ${fonts.primary};
  font-style: normal;
`;

export const HeaderImage = styled.div`
  background-image: url(${LogoCard});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 123px;
  height: 130px;
  width: 100%;
`;

export const TitleModal = styled.h2`
  width: max-content;
  min-height: 46px;
  font-size: 24px;
  line-height: 23px;
`;

export const TextBody = styled.p`
  line-height: 23px;
  font-size: 14px;

  text-align: center;

  width: 85%;

  strong {
    font-weight: 500;
  }

  b {
    color: ${colors.primary};
  }
`;

export const EmailUserStyled = styled.p`
  margin-top: 54px;
  height: 23px;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;

  text-decoration-line: underline;

  color: ${colors.primary};
`;

export const ContentButtons = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding: 50px 30px 30px 30px;

  @media (min-height: 530px) {
    position: absolute;
    bottom: 0;
  }
`;

export const SendLinkEmail = styled.span`
  line-height: 23px;

  text-align: center;
  cursor: pointer;
  color: ${colors.primary};
  height: 23px;
  width: 80%;
  margin-top: 60px;
`;

export const Input = styled.input`
  border: 0 none;
  border-bottom: 1px solid #e8e8e8;

  font-size: 14px;
  line-height: 24px;

  min-width: 70%;
  margin-bottom: 20px;

  :focus {
    border-bottom: 1px solid ${colors.primary};
  }
`;

export const Label = styled.label`
  font-size: 13px;
  line-height: 23px;
  min-width: 70%;
  text-align: left;
  margin-top: 10px;
`;

export const ContentButton = styled.div`
  display: flex;
  width: 80%;
  margin-top: 25px;
`;

export const InformLogin = styled.div`
  width: 50%;
  font-size: 14px;
  line-height: 24px;
  text-align: center;
  margin-bottom: 25px;
  @media ${device.untilMobileL} {
    width: 70%;
  }
`;

export const ContainerSpinner = styled.div`
  display: flex;
  height: 250px;
  width: 100%;
  justify-content: center;
  align-items: center;
`;

export const LoginCustom = styled(Login)`
  font-family: ${fonts.primary};
`;
